import { Injectable } from '@angular/core';
import * as global_var from '../global.variable';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  // Constructor
  constructor(private http: HttpClient, private router: Router) { }
  // Login Form Validation
  loginValidation(data: any) {
    data.username = data.email;
    return this.http.post(global_var.apiUrl + 'login', data
    ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  // Logout active session of user
  logoutSession(data: any) {
    return this.http.post(global_var.apiUrl + 'logoutsession', data
    ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
